import API from '@/utils/API';
import assign from 'lodash/assign';
import * as Sentry from '@sentry/browser';

export const FETCH_DATA_REQUESTED = 'FETCH_DATA_REQUESTED';
export const FETCH_DATA_SUCCESS = 'FETCH_DATA_SUCCESS';

export const initState = {
  data: [],
  isFetching: false,
  isFetched: false,
  error: null,
}

export const mutations = {
  [FETCH_DATA_REQUESTED](state) {
    assign(state, {
      isFetching: true,
    });
  },

  [FETCH_DATA_SUCCESS](state, { data }) {
    assign(state, {
      data,
      isFetching: false,
      isFetched: true,
    });
  },
};

export const actions = {
  async fetch({ commit }) {
    try {
      const results = await API.banks();

      commit(FETCH_DATA_SUCCESS, { data: results.filter(({ name }) => name !== 'default') });
    } catch(error) {
      Sentry.captureException(error);

      return Promise.reject(error);
    }

    return Promise.resolve();
  }
};

export const getters = {
  items: state => state.data.map(bank => ({
    value: { id: bank.id, name: bank.name, shortName: bank.shortName },
    text: bank.name,
  })),
};

export default {
  namespaced: true,

  state: initState,

  mutations,

  actions,

  getters,
};
